const routes: Record<string, () => Promise<unknown>> = {
  "/my-profile": () => import("./pages/MyProfilePage.js"),
  "/settings": () => import("./pages/SettingsPage.js"),
  "/my-requests": () => import("./pages/MyRequestsPage.js"),
  "/applications": () => import("./pages/ApplicationsPage.js"),
  "/staff/applications": () => import("./pages/ApplicationsPage.js"),
  "/admin/applications": () => import("./pages/ApplicationsPage.js"),
  "/members": () => import("./pages/MembersPage.js"),
  "/admin/users": () => import("./pages/UsersPage.js"),
  "/admin/features": () => import("./pages/FeaturesPage.js"),
  "/admin/discord-logs": () => import("./pages/DiscordAuditLogsPage.js"),
  "/admin/server": () => import("./pages/ServerPlayersPage.js"),
  "/admin/compliance": () => import("./pages/CompliancePage.js"),
  "/admin/requests": () => import("./pages/AdminRequestsPage.js"),
  "/admin/pending-approvals": () => import("./pages/PendingApprovalsPage.js"),
  "/admin/audit-log": () => import("./pages/AuditLogPage.js"),
  "/role-mappings": () => import("./pages/RoleMappingsPage.js"),
  "/admin/hub-permissions": () => import("./pages/HubPermissionsPage.js"),
  "/discipline/search": () => import("./pages/DisciplinePage.js"),
  "/community": () => import("./pages/CommunityPage.js"),
  "/feedback": () => import("./pages/FeedbackPage.js"),
};
export function preloadRoute(path: string): void {
  const load = routes[path];
  if (load)
    void load().catch(() => {
      /* Navigation can retry a transient download failure. */
    });
}
